import WorkItemListModelBase from '../_generated/modelBases/work-item-list-model-base';

export default class WorkItemListModel extends WorkItemListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
